import { Page } from "@iq/models";
import { useEffect, useState } from "react";
import useUserStore from "../states/user";
import useAvailabilityStore from "../states/availability";
import { saveAvailability } from "../services/AvailbilityService";
import WeeklyAvailabilityEditor from "../components/WeeklyAvailabilityEditor/WeeklyAvailabilityEditor";
import AvailabilityExceptions from "../components/AvailabilityExceptions/AvailabilityExceptions";
import { DAY_NAMES, timeToMinutes } from "../utils/availabilitySchedule";
import styles from "./Availability.module.css";
import LoadingIcon from "../assets/3-dots-scale.svg";
import { AnimatedReveal } from "@iq/models"
function Availability() {
    const userId = useUserStore((state) => state.session?.profile?.id);
    const availability = useAvailabilityStore((state) => state.availability);
    const setAvailability = useAvailabilityStore((state) => state.setAvailability);
    const fetchCurrentWeekAvailability = useAvailabilityStore((state) => state.fetchCurrentWeekAvailability);
    const [scheduleStatus, setScheduleStatus] = useState({ type: "", message: "" });
    const [isSavingSchedule, setIsSavingSchedule] = useState(false);

    const updateSchedule = (nextAvailability) => {
        setScheduleStatus({ type: "", message: "" });
        setAvailability(nextAvailability);
    };

    const handleSaveAvailability = async () => {
        const invalidDay = availability.find((day) => day.windows.some((window) => {
            const start = timeToMinutes(window.start_time);
            const end = timeToMinutes(window.end_time);
            return start === null || end === null || start >= end;
        }));

        if (invalidDay) {
            setScheduleStatus({
                type: "error",
                message: `${DAY_NAMES[Number(invalidDay.day_of_week)]} needs a valid start and end time.`,
            });
            return;
        }

        setIsSavingSchedule(true);
        setScheduleStatus({ type: "", message: "" });
        try {
            await saveAvailability(availability);
            setScheduleStatus({ type: "success", message: "Schedule saved." });
        } catch (error) {
            setScheduleStatus({ type: "error", message: error.message || "Could not save the schedule." });
        } finally {
            setIsSavingSchedule(false);
        }
    };

    useEffect(() => {
        if (!userId || availability.length > 0) return;
        fetchCurrentWeekAvailability(userId).catch((error) => {
            setScheduleStatus({ type: "error", message: error.message || "Could not load the schedule." });
        });
    }, [userId, availability.length, fetchCurrentWeekAvailability]);

    return (
        <AnimatedReveal stagger={100}>
            <Page>
                    <div className={styles.layout}>
                        <section className={styles.scheduleCard} aria-labelledby="weekly-schedule-title">
                            <div className={styles.cardHeader}>
                                <div>
                                    <h2 id="weekly-schedule-title">Weekly Availability Editor</h2>
                                    <p>Drag to add time. Move or resize blocks to adjust them.</p>
                                </div>
                                <button
                                    className={styles.saveButton}
                                    type="button"
                                    onClick={handleSaveAvailability}
                                    disabled={!userId || isSavingSchedule || availability.length === 0}
                                >
                                    {isSavingSchedule ? "Saving..." : "Save changes"}
                                </button>
                            </div>

                            {scheduleStatus.message && (
                                <p className={`${styles.status} ${styles[scheduleStatus.type]}`} role="status">
                                    {scheduleStatus.message}
                                </p>
                            )}

                            <div className={styles.editor} data-reveal>
                                <WeeklyAvailabilityEditor days={availability} onChange={updateSchedule} />
                            </div>
                        </section>

                        <AvailabilityExceptions/>
                    </div>
            </Page>
        </AnimatedReveal>
    );
}

export default Availability;